import { ProductFilterFormState } from './ProductFilterFormContext'
import { SelectionItem } from '../../../../domain/selectionItem'
import { isSellingProductOnline } from '../../../utils/Product.utils'

export function getProductsFilters(
  products: SelectionItem[],
  formState: ProductFilterFormState,
  isEcommerce: boolean | undefined,
  type: string,
): SelectionItem[] {
  let productsToFilter = products

  if (type !== 'colors') {
    if (formState.colors.length) {
      productsToFilter = productsToFilter.filter(
        ({ couleurMetalExtended }) =>
          couleurMetalExtended && formState.colors.includes(couleurMetalExtended.id),
      )
    }
  }

  if (type !== 'categories') {
    if (formState.types.length) {
      productsToFilter = productsToFilter.filter(
        ({ categoriesOfProduct }) =>
          categoriesOfProduct && formState.types.includes(categoriesOfProduct.id),
      )
    }
  }

  if (type !== 'collections') {
    if (formState.collections.length) {
      productsToFilter = productsToFilter.filter(
        ({ collectionProductExtended }) =>
          collectionProductExtended && formState.collections.includes(collectionProductExtended.id),
      )
    }
  }

  if (formState.availableOnline) {
    productsToFilter = productsToFilter.filter(({ enVente }) =>
      isSellingProductOnline({ en_vente: enVente } as Product, isEcommerce),
    )
  }

  if (type !== 'prices') {
    if (formState.priceRange.min && formState.priceRange.max) {
      productsToFilter = productsToFilter.filter(({ priceRange }) => {
        const price = priceRange?.minimum_price.regular_price.value ?? 0
        return (
          price >= (formState.priceRange.min ?? 0) &&
          price <= (formState.priceRange.max ?? Number.MAX_VALUE)
        )
      })
    }
  }

  return productsToFilter
}
